module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func_en.03374d195b2738825ebcbbd11e2f7696.png";